import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/forms.css";
import "./styles/live-map.css";
import "./styles/alarms.css";
import "./styles/geofences.css";
import "./styles/checklist.css";
import "./styles/modules.css";
import "./styles/pwa.css";
import "./styles/login.css";
import { installPreloadRecovery } from "./pwa/preload";
import { registerServiceWorker } from "./pwa/register";

// Production builds only: app-shell cache, update prompt and web push (ADR 0019).
registerServiceWorker();
// A lazy chunk replaced by a deploy: reload once onto the new version (loop-guarded).
installPreloadRecovery();

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
